export default __webpack_public_path__ + "static/sarpl-logo-63d3a34bd53886e47db656d0b5485372.png";